module.exports = __webpack_public_path__ + "img/phone-div2.702b5399.png";